import { ConnectionNames } from "../../../contracts";
export const ConfigStore = {
    config: {
        inactiveTTL_MS: 10000,
        connections: {},
        urls: {},
        requestToken: () => Promise.resolve("default-token"),
        onTokenRenew: () => () => undefined,
        siteName: "dk-sandbox",
        tracking: {
            [ConnectionNames.sports]: {
                trackError: () => undefined,
                trackData: () => undefined
            }
        }
    }
};
//# sourceMappingURL=index.js.map